<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <h1 class="heading">Fast geschafft!</h1>

      <div class="img-progress-bar-wrapper">
        <img class="img-progress-bar" src="assets/icon/Progress-bar.svg" />
      </div>

      <p class="info-text">
        Ihre Bestellung wird jetzt bearbeitet. Um Ihren Kauf abzuschließen,
        klicken Sie bitte auf den Verifizierungslink, den
        wir&nbsp;Ihnen&nbsp;geschickt&nbsp;haben:
      </p>

      <p class="email-address">{{ emailaddress }}</p>

      <div class="button-wrapper">
        <button
          class="send-email-button"
          (click)="resendMail()"
          [ngClass]="{ 'resend-mail-button-pressed': buttonPressedState }"
        >
          E-mail erneut senden
        </button>
      </div>

      <div class="button-link-wrapper">
        <zaver-button-link
          [text]="'E-Mail Adresse nicht korrekt?'"
          (click)="onClickReset()"
        ></zaver-button-link>
      </div>
    </div>
  </div>
</div>

<zaver-details-modal
  *ngIf="modalActive"
  (onClose)="setModalActive(false)"
  [color]="'#E6E9EF'"
  [title]="'Daten ändern'"
  [titleColor]="'#1B2235'"
>
  <div class="small-modal-wrapper">
    <div class="modal-text">
      Um Ihre e-mail Adresse zu ändern müssen Sie die vorherigen Schritten
      erneut durchführen.
    </div>
    <div class="modal-button-container">
      <button class="modal-button" (click)="setModalActive(false)">
        Nein, abbrechen
      </button>

      <button
        class="modal-button"
        [disabled]="navigationInProgress"
        (click)="resetEmail()"
      >
        Ja, ändern
      </button>
    </div>
  </div>
</zaver-details-modal>
